<template>
    <div class="laptop">
      <img src="/images/promo/connect-features/laptop.svg" alt="Laptop image" />
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.laptop {
    display: flex;
    justify-content: center;
}
</style>
